<template>
<div>
  <saved-search-list v-if="!create" :items="items" :fields-config="fieldsConfig" :category-list="categoryList" @remove="remove" @save="save"></saved-search-list>

  <div v-if="create" class="savedsearch__wrapper">
    <button class="savedsearch__cancel"
            @click="create = false"
            :title="$t('Abbrechen')">
        <span class="far fa-times"></span>
    </button>
    <saved-search-wizard @sent="onCreated" class="mt-10"></saved-search-wizard>
  </div>
  <div v-else class="wp-block-button text-center mt-10">
    <a class="btn btn-primary"
       @click="create = true">{{ $t("Neues Suchprofil erstellen") }}</a>
  </div>

  <div class="mt-10" v-if="recommendations && recommendations.length > 0">
    <hr />

    <h3 class="text-center mt-10 mb-0">{{ $t("Interessante Objekte", { n: recommendations.length }) }}</h3>

    <expose-list :items="recommendations"></expose-list>

    <div class="wp-block-button text-center mt-10">
      <a class="btn btn-primary"
         @click="sendEmail()">{{ $t("Empfehlungen per E-Mail versenden") }}</a>
    </div>
  </div>
</div>
</template>

<script>
import SavedSearchList from "./SavedSearchList";
import SavedSearchWizard from "./contact/SavedSearchWizard";
import ExposeList from "./ExposeList";
import config from "./contact/ConfigSearchInquiry";
import inquiryFieldsConfig from "./utils/InquiryFieldsConfig";

export default {
  name: "SavedSearchListContainer",

  components: {
    SavedSearchList,
    SavedSearchWizard,
    ExposeList
  },

  computed: {
    items() {
      return this.$store.state.savedsearch.list;
    },

    recommendations() {
      return this.$store.state.savedsearch.recommendations;
    }
  },

  data() {
    return {
      categoryList: config.categoryList,
      fieldsConfig: null,
      confirm: false,
      create: false
    }
  },

  created() {
    this.$store.dispatch("savedsearch/loadAll");
    this.$store.dispatch("savedsearch/loadRecommendations");

    inquiryFieldsConfig(config, t => {
      return this.$t(t);
    }).then(fieldsConfig => {
      this.fieldsConfig = fieldsConfig;
    });
  },

  methods: {
    remove(ss) {
      this.$store.dispatch("savedsearch/delete", ss.id).then(() => {
        this.$store.dispatch("savedsearch/loadAll");
        this.$store.dispatch("savedsearch/loadRecommendations");
      });
    },

    save(inquiry) {
      this.$store.dispatch("savedsearch/save", inquiry).then(() => {
        this.$store.dispatch("savedsearch/loadAll");
        this.$store.dispatch("savedsearch/loadRecommendations");
      });
    },

    onCreated() {
      this.$store.dispatch("savedsearch/loadAll");
      this.$store.dispatch("savedsearch/loadRecommendations");
      this.create = false;
    },

    sendEmail() {
      this.$store.dispatch("savedsearch/sendRecommendatationsEmail");
    }
  }
};
</script>
